export type PhaseTaskCounts = {
	taskCount?: number | null;
	doneCount?: number | null;
};

export type PhaseTaskBreakdown = {
	/** True when the phase has no tasks at all — render sensibly (0/0), never NaN. */
	empty: boolean;
	doneCount: number;
	taskCount: number;
	/**
	 * Integer 0–100. Read off `doneCount` / `taskCount`, NOT the phase's manual progress:
	 * under manual progress a PM can type 100% while tasks remain open, and the sign-off
	 * modal must reflect what will actually be signed for, which is task completion.
	 */
	percent: number;
};

/**
 * Derive the firm-owned breakdown row from the same done/total totals the scoping table
 * already aggregates. An empty phase (or one whose totals have not yet resolved) renders
 * 0 / 0 at 0% rather than `NaN%` — the modal opens on real project data, not on a promise.
 */
export function derivePhaseTaskBreakdown(counts: PhaseTaskCounts | null | undefined): PhaseTaskBreakdown {
	const rawTaskCount = counts?.taskCount;
	const rawDoneCount = counts?.doneCount;
	const taskCount =
		typeof rawTaskCount === 'number' && Number.isFinite(rawTaskCount) && rawTaskCount > 0 ? Math.floor(rawTaskCount) : 0;
	const doneCount =
		typeof rawDoneCount === 'number' && Number.isFinite(rawDoneCount) && rawDoneCount > 0
			? Math.min(Math.floor(rawDoneCount), taskCount)
			: 0;
	const empty = taskCount === 0;
	const percent = empty ? 0 : Math.round((doneCount / taskCount) * 100);
	return {empty, doneCount, taskCount, percent};
}
